import { AbstractModel } from '@/models/abstractModel';
import { useBookmakerDictionary } from '@/stores';
import type { IMonitoringAccount } from '@/types';

export class MonitoringAccount extends AbstractModel {
    public allocatedAccountCount?: number;
    public busyAccountCount?: number;
    public disabledAccountCount: number;
    public loggedInAccountCount: number;
    public loggedOutAccountCount: number;
    public notAllocatedAccountCount?: number;
    public siteId: number;
    public totalAccountCount: number;

    constructor(data: IMonitoringAccount) {
        super();
        this.siteId = data.site_id;
        this.totalAccountCount = data.total_account_count;
        this.allocatedAccountCount = data.allocated_account_count;
        this.notAllocatedAccountCount = data.not_allocated_account_count;
        this.loggedInAccountCount = data.logged_in_account_count;
        this.busyAccountCount = data.busy_account_count;
        this.loggedOutAccountCount = data.logged_out_account_count;
        this.disabledAccountCount = data.disabled_account_count;
    }

    get allocatedDisplay(): number {
        return this.busyAccountCount ?? 0;
    }

    get bookmakerName(): string {
        try {
            const bookmakerDictionary = useBookmakerDictionary();
            return bookmakerDictionary.nameById(this.siteId) || '';
        } catch {
            return '';
        }
    }

    get disabledClass(): string {
        return this.disabledAccountCount > 0 ? 'text-tbRed' : 'text-tbGreen';
    }

    get freeClass(): string {
        return (this.notAllocatedAccountCount ?? 0) > 0 ? 'text-tbRed' : 'text-tbGreen';
    }

    get freeDisplay(): number {
        return this.notAllocatedAccountCount ?? 0;
    }

    get loggedOutClass(): string {
        return this.loggedOutAccountCount > 0 ? 'text-grey' : 'text-tbGreen';
    }

    get messageClass(): string {
        return (this.busyAccountCount ?? 0) > 0 ? 'text-tbYellow' : 'text-tbGreen';
    }

    get messageDisplay(): number {
        return this.busyAccountCount ?? 0;
    }

    get statusClass(): string {
        return this.totalAccountCount > this.loggedInAccountCount ? 'status-yellow' : 'status-green';
    }
}
